import { render, staticRenderFns } from "./MalariaResultPanel.vue?vue&type=template&id=3b6facdb&scoped=true"
import script from "./MalariaResultPanel.vue?vue&type=script&lang=js"
export * from "./MalariaResultPanel.vue?vue&type=script&lang=js"
import style0 from "./MalariaResultPanel.vue?vue&type=style&index=0&id=3b6facdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6facdb",
  null
  
)

export default component.exports